import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronLeft, faChevronRight, faArrowRotateBack } from '@fortawesome/free-solid-svg-icons'
import "./Controls.css"
import { useNavigate } from "react-router-dom"

const Controls = (props)=>{
    const {next, previous} = props
    const navigate = useNavigate()
    return(
        <div className="controls">
            <div className="arrows">
                <div className="arrow" onClick={previous}>
                    <FontAwesomeIcon icon={faChevronLeft} size="3x" color="#ab354d" />
                    <span>anterior</span>
                </div>
                <div className="arrow" onClick={next}>
                    <FontAwesomeIcon icon={faChevronRight} size="3x" color="#ab354d"/>
                    <span>siguiente</span>
                </div>
            </div>
            <div className="back-home" onClick={()=>navigate("/")}>
                <FontAwesomeIcon icon={faArrowRotateBack} size="2x" color= "#ab354d"/>
                <span>ir al menú<br></br>principal</span>
            </div>
        </div>
    )
}

export default Controls;